/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from 'react';
import PropTypes from 'prop-types';
import * as Accordion from '@radix-ui/react-accordion';
import DecodeHtml from '@/utils/Common/DecodeHtml';
import useMatchMedia from '@/hooks/useMatchMedia';
import Icon from '../atoms/Icon';

const DLGContactUsInfoComponent = ({ glyph, content, title }) => {
  const forceOpen = useMatchMedia('(min-width:600px)');
  return (
    <Accordion.Root
      className='dln-contactUs__accordion'
      collapsible
      value={forceOpen ? 'open' : undefined}
    >
      <Accordion.Item value='open'>
        <Accordion.Trigger className='dln-contactUs__accordionTrigger'>
          <>
            <Icon glyph={glyph} modifiers={['main']} />
            <h2 className='dln-contactUs__accordionTitle'>{title}</h2>
            <Icon glyph='u' modifiers={['arrow-down']} />
          </>
        </Accordion.Trigger>
        <Accordion.Content className='dln-contactUs__accordionContent dln-contactUs__infoAccordionContent'>
          <div dangerouslySetInnerHTML={{ __html: DecodeHtml(content) }} />
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};

DLGContactUsInfoComponent.propTypes = {
  content: PropTypes.string.isRequired,
  glyph: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

DLGContactUsInfoComponent.defaultProps = {};

export default DLGContactUsInfoComponent;
